export default __webpack_public_path__ + "static/media/imagenbanner.afa24e49.png";